export default __webpack_public_path__ + "static/media/plinio_giovane.bab96b5a.jpg";